import { createFileRoute, Link } from "@tanstack/react-router";
import { toast } from "sonner";
import templateMarkdown from "@/lib/email/teardown-delivery-template.md?raw";

export const Route = createFileRoute("/admin/templates/teardown-delivery")({
  head: () => ({
    meta: [
      { title: "Teardown Delivery Template · Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: TeardownDeliveryTemplatePage,
});

function TeardownDeliveryTemplatePage() {
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(templateMarkdown);
      toast.success("Template copied to clipboard");
    } catch {
      toast.error("Couldn't copy, select and copy manually");
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <Link to="/admin/dashboard" className="text-xs text-muted-foreground hover:text-foreground">
          ← Back to dashboard
        </Link>
        <h1 className="mt-2 font-display text-2xl font-semibold text-foreground">
          Teardown Delivery Template
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Copy this template when delivering a Performance Teardown order. Fill in the bracketed
          placeholders, then paste into your email client. Remove the operator notes at the bottom
          before sending.
        </p>
      </div>

      <div className="rounded-2xl border border-border bg-card/30 p-6">
        <div className="flex items-center justify-between gap-3">
          <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
            Markdown source
          </p>
          <button
            type="button"
            onClick={onCopy}
            className="rounded-full bg-foreground px-4 py-1.5 text-xs font-medium text-background hover:opacity-90"
          >
            Copy to clipboard
          </button>
        </div>
        <pre className="mt-4 max-h-[70vh] overflow-auto whitespace-pre-wrap rounded-xl border border-border bg-background p-4 font-mono text-xs leading-relaxed text-foreground">
          {templateMarkdown}
        </pre>
      </div>
    </div>
  );
}
